// @flow

import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getIsDebugEnabled } from '@alphaott/smart-tv-debug/selectors'
import { setDebugMode } from '@alphaott/smart-tv-debug/actions'

interface UseDebugModeResult {
  isDebugEnabled: boolean;
  onToggleDebugMode: () => void;
}

export const useDebugMode = (): UseDebugModeResult => {
  const dispatch = useDispatch()

  const isDebugEnabled = useSelector(getIsDebugEnabled)

  const onToggleDebugMode = useCallback(
    () => dispatch(setDebugMode(!isDebugEnabled)),
    [dispatch, isDebugEnabled],
  )

  return {
    isDebugEnabled,
    onToggleDebugMode,
  }
}

export default useDebugMode
